// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = "/auth";
const ROOTS_AFFILIATE = "/affiliate";
const ROOTS_SALES = "/sales";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: "/login",
  loginVerify: "/login-verify",
  resetPassword: "/reset",
  signUp: "/sign-up",
  signUpMobileVerify: "/sign-up-mobile-verify",
  signUpEmailVerify: "/sign-up-email-verify",
};

export const PATH_KYC = {
  businessVerification: "/kyc/businessVerification",
  businessDocuments: "/kyc/businessDocuments",
  directorAndPromoter: "/kyc/directorAndPromoter",
  DirectorDocuments: "/kyc/DirectorDocuments",
  ApplicationReview: "/kyc/ApplicationReview",
};

export const PATH_BANK = {
  BankSelection: "/bank/BankSelection",
  BankSelectionSteps: "/bank/BankSelectionSteps",
  BankOSV: "/bank/BankOSV",
  BankAccountOpen: "/bank/BankAccountOpen",
  BankAccountSetUp: "/bank/BankAccountSetUp",
  WithdrawalBankAccount: "/bank/WithdrawalBankAccount",
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  home: {
    root: path(ROOTS_DASHBOARD, "/home/dashboard"),
    uploadNewinvoice: path(ROOTS_DASHBOARD, "/home/uploadNewinvoice"),
    myPayables: {
      root: path(ROOTS_DASHBOARD, "/home/myPayables"),
      list: path(ROOTS_DASHBOARD, "/home/myPayables/list"),
      view: path(ROOTS_DASHBOARD, "/home/myPayables/view"),
    },
    pendingPayables: {
      root: path(ROOTS_DASHBOARD, "/home/pendingPayables"),
      list: path(ROOTS_DASHBOARD, "/home/pendingPayables/list"),
      detail: path(ROOTS_DASHBOARD, "/home/pendingPayables/details"),
      view: (id: string) =>
        path(ROOTS_DASHBOARD, `/home/pendingPayables/view/${id}`),
      makepayment: (id: string) =>
        path(ROOTS_DASHBOARD, `/home/pendingPayables/view/${id}/MakePayment`),
      successpayment: (id: string) =>
        path(
          ROOTS_DASHBOARD,
          `/home/pendingPayables/view/${id}/SuccessPayment`,
        ),
    },
    myReceivables: {
      root: path(ROOTS_DASHBOARD, "/home/myReceivables"),
      list: path(ROOTS_DASHBOARD, "/home/myReceivables/list"),
      view: path(ROOTS_DASHBOARD, "/home/myReceivables/view"),
    },
    pendingReceivables: {
      root: path(ROOTS_DASHBOARD, "/home/pendingReceivables"),
      list: path(ROOTS_DASHBOARD, "/home/pendingReceivables/list"),
      view: path(ROOTS_DASHBOARD, "/home/pendingReceivables/view"),
    },
    newConnections: path(ROOTS_DASHBOARD, "/home/newConnections"),
  },
  AccessControl: path(ROOTS_DASHBOARD, "/AccessControl"),
  reports: path(ROOTS_DASHBOARD, "/reports"),
  assuredPayBilling: path(ROOTS_DASHBOARD, "/assuredPayBilling"),
  BankAccounts: path(ROOTS_DASHBOARD, "/BankAccounts"),
  TermsAndCondition: path(ROOTS_DASHBOARD, "/TermsAndCondition"),
  Chat: path(ROOTS_DASHBOARD, "/Chat"),
  Profile: path(ROOTS_DASHBOARD, "/Profile"),
  Leads: path(ROOTS_DASHBOARD, "/Leads"),
  support: path(ROOTS_DASHBOARD, "/support"),
  Ticket: {
    root: path(ROOTS_DASHBOARD, "/Ticket"),
    createTicket: path(ROOTS_DASHBOARD, "/Ticket/create_ticket"),
  },
};

export const PATH_AFFILIATE = {
  root: ROOTS_AFFILIATE,
  dashboard: path(ROOTS_AFFILIATE, "/dashboard"),
  invitation: path(ROOTS_AFFILIATE, "/invitation"),
  ["bank-accounts"]: path(ROOTS_AFFILIATE, "/bank-accounts"),
  Commission: path(ROOTS_AFFILIATE, "/Commission"),
  Leads: path(ROOTS_AFFILIATE, "/Leads"),
};

export const PATH_SALES = {
  root: ROOTS_SALES,
  dashboard: path(ROOTS_SALES, "/dashboard"),
  inviteAffiliateUser: path(ROOTS_SALES, "/inviteAffiliateUser"),
  team: path(ROOTS_SALES, "/team"),
  performance: path(ROOTS_SALES, "/performance"),
  leads: path(ROOTS_SALES, "/leads"),
  clients: path(ROOTS_SALES, "/clients"),
  commission: path(ROOTS_SALES, "/commission"),
  analytics: path(ROOTS_SALES, "/analytics"),
  profile: path(ROOTS_SALES, "/profile"),
  Leads: path(ROOTS_SALES, "/Leads"),
};
